export default __webpack_public_path__ + "static/media/info_bg_mobile.8bb53c59.png";